<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveCampaign()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Nome da campanha</label>
                <input
                  id="name"
                  v-model="campaign.name"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.campaign.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.campaign.name.required"
                  class="invalid-feedback"
                >
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="type_contact">Destinatários</label>
                <select
                  id="type_contact"
                  v-model="campaign.type_contact"
                  name="type_contact"
                  type="text"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.campaign.type_contact.$error
                  }"
                >
                  <option></option>
                  <option value="guests">Convidados</option>
                  <option value="registered">Inscritos</option>
                </select>
                <div
                  v-if="submitted && !$v.campaign.type_contact.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="{ 'col-sm-6': campaign.type_filter, 'col-sm-12': !campaign.type_filter }">
              <div class="form-group">
                <label for="type_filter">Filtrar</label>
                <select
                  class="custom-select"
                  name="type_filter"
                  v-model="campaign.type_filter"
                  @change="setFilterCampaign()"
                >
                  <option value=""></option>
                  <option value="rooms">Salas</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" v-if="campaign.type_filter === 'rooms'">
                <label for="type">Salas</label>
                <multiselect tag-placeholder="Selecione ma ou mais salas" placeholder="Selecione uma ou mais salas" v-model="campaign.rooms" label="name" track-by="id" :options="rooms" :multiple="true"></multiselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="template_id">Template</label>
                <select
                  class="custom-select"
                  name="template_id"
                  v-model="campaign.template_id"
                  @change="setTemplate(campaign.template_id)"
                  :class="{
                    'is-invalid': submitted && $v.campaign.template_id.$error
                  }"
                >
                  <option></option>
                  <option v-for="(t,i) in emailtemplates" :key=i :value="t.id">{{ t.subject }}</option>
                </select>
                <div
                  v-if="submitted && !$v.campaign.template_id.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
                <button type="button" class="btn btn-outline-dark btn-sm mt-2" v-if="campaign.template_id" @click="showExampleTemplate">
                  <i class="bx bx-show link" ></i> Ver exemplo do template
                </button>
              </div>
            </div>
          </div>
          <div class="row" v-if="showHeader">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="header_banner">Header Imagem</label>
                <input
                  class="form-control"
                  ref="header_banner"
                  name="header_banner"
                  type="file"
                >
                <div
                  v-if="showHeader"
                  class="invalid-feedback"
                >
                  Template escolhido exige uma imagem no HEADER.
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 1rem">
            <div class="col-sm-3">
              <div style="display:flex; align-items: start; gap: 5px;margin-top: 0.55rem">
                <span style="font-weight: 500;margin-top:2px">Agendar disparo</span>
                <b-form-checkbox v-model="campaign.has_scheduled_at" switch size="lg"></b-form-checkbox>
              </div>
            </div>
            <div class="col-sm-4" v-if="campaign.has_scheduled_at">
              <!-- <label for="scheduled_at">Data do Agendamento</label> -->
              <date-picker
                v-model="campaign.scheduled_at"
                type="datetime"
                :first-day-of-week="1"
                lang="pt-br"
                format="DD/MM/YYYY HH:mm"
                name="scheduled_at"
              >
              </date-picker>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveCampaign()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import Multiselect from 'vue-multiselect'
import roomService from '@/pages/rooms/services'

export default {
  components: {
    Loading,
    DatePicker,
    Multiselect
  },
  props: {
    idcampaign: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Nova Campanha',
      showHeader: false,
      loading: true,
      fullPage: true,
      submitted: false,
      checklist: [
        { id: 1, name: 'SIM' }
      ],
      campaign: {
        rooms: []
      },
      modal: false
    }
  },
  validations: {
    campaign: {
      name: { required },
      type_contact: { required },
      template_id: { required }
    }
  },
  methods: {
    ...mapActions('ecampaign', {
      getCampaign: 'show',
      postData: 'save'
    }),
    ...mapActions('emailTemplate', {
      getTemplatesAll: 'getAll'
    }),
    setTemplate (templateId) {
      if (templateId) {
        const template = this.emailtemplates.filter((t) => t.id === this.campaign.template_id)[0]
        if (template) {
          // this.showHeader = template.components[0].format === 'IMAGE'
        }
      }
    },
    showExampleTemplate () {
      const template = this.emailtemplates.filter((t) => t.id === this.campaign.template_id)[0]
      if (template) {
        this.$emit('exampleTemplate', template.content)
      }
    },
    setFilterCampaign () {
      this.campaign.rooms = []
    },
    loadItem (id) {
      if (id) {
        this.title = 'Editar Campanha'
        this.getCampaign(id).then((data) => {
          this.campaign = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    getTemplates () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getTemplatesAll(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getRooms () {
      roomService.list({ type: 1 }).then((res) => {
        this.rooms = res.data.data
      })
    },
    open (id = null) {
      this.getRooms()
      this.getTemplates()
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveCampaign () {
      this.submitted = true
      this.$v.campaign.$touch()
      if (this.$v.campaign.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      if (this.campaign.has_scheduled_at) {
        this.campaign.scheduled_at = this.$moment(this.campaign.scheduled_at).format('YYYY-MM-DD HH:mm:ss')
      }

      const formData = new FormData()
      formData.append('id', this.campaign.id || '')
      formData.append('name', this.campaign.name)
      formData.append('type_contact', this.campaign.type_contact)
      formData.append('type_filter', this.campaign.type_filter || '')
      formData.append('template_id', this.campaign.template_id)
      formData.append('status', JSON.stringify(this.campaign.status))
      formData.append('groups', JSON.stringify(this.campaign.groups))
      formData.append('tags', JSON.stringify(this.campaign.tags))
      formData.append('checkin', JSON.stringify(this.campaign.checkin))
      formData.append('has_scheduled_at', this.campaign.has_scheduled_at)
      formData.append('scheduled_at', this.campaign.scheduled_at)

      await this.postData(formData).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.campaign = {}
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('ecampaign', { data: 'campaign' }),
    ...mapState('emailTemplate', ['emailtemplates'])
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
